module.exports = __webpack_public_path__ + "img/facebook-logo.d6bd0a6f.svg";